import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1),
    },
    formControlAuto: {
        width: '90%',
    },
    field: {
        width: '90%',
    },
    w90: {
        width: '90%'
    },
    root: {
        flexGrow: 1,
    },
    successIcon: {
        color: 'green'
    },
    errorIcon: {
        color: 'red'
    },
    iconsContainer:{
        position:'absolute',
        right:'20px',
        top:'20px'

    }
}));

export function mapPaymentFeeScheduleRules(groupedData) {
    const localFeeSchedules = groupedData.localFeeSchedules.map(group => {
        return {
            ...group,
            isAnesthesia: group.feeSchedule?.isAnesthesia === true,
            rules: group.rules.map(r => ({
                ruleId: r.id,
                ruleName: r.name,
                ruleFeeScheduleGroupXrefId: r.ruleFeeScheduleGroupXrefId,
                fromDate: r.fromDate,
                toDate: r.toDate,
                sourceLabel: r.sourceLabel,
                sourceLabelId: r.sourceLabelId,
                targetFeeScheduleId: { id: 0, name: "Select Fee Schedule At Target" },
                targetLabelId: null,
                isRBRVS: false,
                selectedState: null,
                selectedLocality: null,
                selectedGpci: null,
            }))
        };
    });

    const globalFeeSchedules = groupedData.globalFeeSchedules.map(group => {
        const isRBRVSGroup = group.feeScheduleName?.toUpperCase()?.includes("RBRVS") || group.feeScheduleName?.toUpperCase()?.includes("ANESTHESIA");
        const isDMEGroup = group.feeScheduleName?.toUpperCase()?.includes("DME");

        return {
            ...group,
            rules: group.rules.map(r => {
                const xref = r.ruleFeeScheduleGroupXref?.find(x => x.id === r.ruleFeeScheduleGroupXrefId);
                return {
                    ruleId: r.id,
                    ruleName: r.name,
                    ruleFeeScheduleGroupXrefId: r.ruleFeeScheduleGroupXrefId,
                    fromDate: r.fromDate,
                    toDate: r.toDate,
                    sourceLabel: r.sourceLabel,
                    sourceLabelId: r.sourceLabelId,
                    targetFeeScheduleId: { id: group.sourceFeeScheduleId, name: group.feeScheduleName },
                    targetLabelId: r.sourceLabelId ? { id: r.sourceLabelId, label: r.sourceLabel } : null,
                    isRBRVS: isRBRVSGroup,
                    isDME:isDMEGroup,
                    selectedState: xref?.globalFeescheduleState || null,
                    selectedLocality: xref?.globalFeescheduleLocality || null,
                    selectedGpci: xref?.globalFeescheduleGPCI || null,
                };
            })
        };
    });

    return {
        localFeeSchedules,
        globalFeeSchedules
    };
}

export function groupFeeSchedules(data) {
  const result = {
    localFeeSchedules: [],
    globalFeeSchedules: []
  };

  const localMap = new Map();
  const globalMap = new Map();

  data.forEach(rule => {

    if (!rule.globalFeeScheduleId) {
      // LOCAL
      const fsId = rule.feeSchedule?.id;
      if (!fsId) return;
      
      const key = String(fsId);

      if (!localMap.has(key)) {
        localMap.set(key, {
          feeScheduleId: fsId,
          feeSchedule: rule.feeSchedule,
          rules: []
        });
      }

      localMap.get(key).rules.push(rule);
    } else {
      // GLOBAL
      const fsId = rule.globalFeeSchedule?.id;
      if (!fsId) return;
      
      const key = String(fsId);

      if (!globalMap.has(key)) {
        globalMap.set(key, {

          globalFeeScheduleId: fsId,
          globalFeeSchedule: rule?.globalFeeSchedule,
          rules: []
        });
      }

      globalMap.get(key).rules.push(rule);
    }
  });

  result.localFeeSchedules = Array.from(localMap.values());
  result.globalFeeSchedules = Array.from(globalMap.values());

  return result;
}


export function mapFeeScheduleRules(groupedData) {
  const localFeeSchedules = groupedData.localFeeSchedules.map(group => {
    return {
      sourceFeeScheduleId: group.feeSchedule?.id ?? null,
      feeScheduleName: group.feeSchedule?.name ?? "",
      newFeeScheduleName: group.feeSchedule?.name ?? "",
      isAnesthesia: group.feeSchedule?.isAnesthesia === true,
      rules: group.rules.map(r => ({
          ruleId: r.id,
          ruleName: r.name,
          targetFeeScheduleId: { id: 0, name: "Select Fee Schedule At Target" },
          feescheduleLabelToRateXRef: null,
          isRBRVS: false,
          selectedState: null,
          selectedLocality: null,
          selectedGpci: null,
      }))
    };
  });

  const globalFeeSchedules = groupedData.globalFeeSchedules.map(group => {
    // Check if group is RBRVS (heuristic)
    const isRBRVSGroup = group.globalFeeSchedule?.name?.toUpperCase()?.includes("RBRVS") || group.globalFeeSchedule?.name?.toUpperCase()?.includes("ANESTHESIA");
    const isDMEGroup = group.globalFeeSchedule?.name?.toUpperCase()?.includes("DME");

    return {
      sourceFeeScheduleId: group.globalFeeSchedule?.id ?? null,
      feeScheduleName: group.globalFeeSchedule?.name ?? "",
      newFeeScheduleName: "",
      rules: group.rules.map(r => {

        return {
            ruleId: r.id,
            ruleName: r.name,
            targetFeeScheduleId: { id: group.globalFeeScheduleId, name: group.globalFeeSchedule?.name || "Select Fee Schedule At Target" },
            feescheduleLabelToRateXRef: group?.globalFeescheduleLabelToRateXRef ?? null,
            // RBRVS Fields (per rule)
            isRBRVS: isRBRVSGroup,
            isDME: isDMEGroup,
            selectedState: r?.globalFeeScheduleState || null,
            selectedLocality: r?.globalFeeScheduleLocality || null,
            selectedGpci: r?.globalFeeScheduleGPCI || null,
          };
      })
    };
  });

  return {
    localFeeSchedules,
    globalFeeSchedules
  };
}

export function groupPaymentFeeSchedules(data) {

  const result = {
    localFeeSchedules: [],
    globalFeeSchedules: []
  };

  const localMap = new Map();
  const globalMap = new Map();

  data.forEach(rule => {
    (rule.ruleFeeScheduleGroupXref || []).forEach(pfs => {
      const isGlobal = Boolean(pfs.globalFeeScheduleId);
      const fsId = pfs.feeScheduleId || pfs.globalFeeScheduleId;
      const fsName = pfs.feeSchedule?.name || pfs.globalFeeSchedule?.name;
      const labelId = pfs.feescheduleLabelToRateXRefId || pfs.globalFeescheduleLabelToRateXRefId;
      const labelName = pfs.feescheduleLabelToRateXRef?.label || pfs.globalFeescheduleLabelToRateXRef?.label;

      if (!fsId) return;

      const key = `${fsId}`;

      if (!isGlobal) {
        if (!localMap.has(key)) {
          localMap.set(key, {
            sourceFeeScheduleId: fsId,
            feeScheduleName: fsName,
            newFeeScheduleName: fsName || "",
            feeSchedule: pfs.feeSchedule,
            rules: []
          });
        }
        localMap.get(key).rules.push({
          ...rule,
          ruleFeeScheduleGroupXrefId: pfs.id,
          fromDate: pfs.fromDate,
          toDate: pfs.toDate,
          sourceLabel: labelName,
          sourceLabelId: labelId
        });
      } else {
        if (!globalMap.has(key)) {
          globalMap.set(key, {
            sourceFeeScheduleId: fsId,
            feeScheduleName: fsName,
            newFeeScheduleName: "",
            rules: []
          });
        }
        globalMap.get(key).rules.push({
          ...rule,
          ruleFeeScheduleGroupXrefId: pfs.id,
          fromDate: pfs.fromDate,
          toDate: pfs.toDate,
          sourceLabel: labelName,
          sourceLabelId: labelId
        });
      }
    });
  });

  result.localFeeSchedules = Array.from(localMap.values());
  result.globalFeeSchedules = Array.from(globalMap.values());

  return result;
}

export function groupLesserOfConfigurations(data) {
  const result = {
    localFeeSchedules: [],
    globalFeeSchedules: []
  };

  const localMap = new Map();
  const globalMap = new Map();

  data.forEach(rule => {
    const feeScheduleConfigs = (rule.lesserOfConfiguration || []).filter(config => config.lesserOfType === 'FeeSchedule');

    feeScheduleConfigs.forEach(config => {
      const isGlobal = Boolean(config.globalFeeScheduleId);
      const fsId = config.feeScheduleId || config.globalFeeScheduleId;
      const fsName = config.feeSchedule?.name || config.globalFeeSchedule?.name;
      const labelId = config.feeScheduleLabelToRateXRefId || config.globalFeescheduleLabelToRateXRefId;
      const labelName = config.feescheduleLabelToRateXRef?.label || config.globalFeescheduleLabelToRateXRef?.label;

      if (!fsId) return;

      const key = `${fsId}`;

      if (!isGlobal) {
        if (!localMap.has(key)) {
          localMap.set(key, {
            sourceFeeScheduleId: fsId,
            feeScheduleName: fsName,
            newFeeScheduleName: fsName || "",
            feeSchedule: config.feeSchedule,
            rules: []
          });
        }
        localMap.get(key).rules.push({
          ...rule,
          lesserOfConfigurationId: config.id,
          percentage: config.percentage,
          sourceLabel: labelName,
          sourceLabelId: labelId
        });
      } else {
        if (!globalMap.has(key)) {
          globalMap.set(key, {
            sourceFeeScheduleId: fsId,
            feeScheduleName: fsName,
            newFeeScheduleName: "",
            rules: []
          });
        }
        globalMap.get(key).rules.push({
          ...rule,
          lesserOfConfigurationId: config.id,
          percentage: config.percentage,
          sourceLabel: labelName,
          sourceLabelId: labelId
        });
      }
    });
  });

  result.localFeeSchedules = Array.from(localMap.values());
  result.globalFeeSchedules = Array.from(globalMap.values());

  return result;
}

export function mapLesserOfRules(groupedData) {
    const localFeeSchedules = groupedData.localFeeSchedules.map(group => {
        return {
            ...group,
            isAnesthesia: group.feeSchedule?.isAnesthesia === true,
            rules: group.rules.map(r => {
                const config = r.lesserOfConfiguration?.find(c => c.id === r.lesserOfConfigurationId);
                return {
                    ruleId: r.id,
                    ruleName: r.name,
                    lesserOfConfigurationId: r.lesserOfConfigurationId,
                    percentage: r.percentage,
                    sourceLabel: r.sourceLabel,
                    sourceLabelId: r.sourceLabelId,
                    targetFeeScheduleId: { id: 0, name: "Select Fee Schedule At Target" },
                    targetLabelId: null,
                    isRBRVS: false,
                    selectedState: null,
                    selectedLocality: null,
                    selectedGpci: null,
                };
            })
        };
    });

    const globalFeeSchedules = groupedData.globalFeeSchedules.map(group => {
        const isRBRVSGroup = group.feeScheduleName?.toUpperCase()?.includes("RBRVS") || group.feeScheduleName?.toUpperCase()?.includes("ANESTHESIA");
        const isDMEGroup = group.feeScheduleName?.toUpperCase()?.includes("DME");
        
        return {
            ...group,
            rules: group.rules.map(r => {
                const config = r.lesserOfConfiguration?.find(c => c.id === r.lesserOfConfigurationId);
                return {
                    ruleId: r.id,
                    ruleName: r.name,
                    lesserOfConfigurationId: r.lesserOfConfigurationId,
                    percentage: r.percentage,
                    sourceLabel: r.sourceLabel,
                    sourceLabelId: r.sourceLabelId,
                    targetFeeScheduleId: { id: group.sourceFeeScheduleId, name: group.feeScheduleName },
                    targetLabelId: r.sourceLabelId ? { id: r.sourceLabelId, label: r.sourceLabel } : null,
                    isRBRVS: isRBRVSGroup,
                    isDME: isDMEGroup,
                    selectedState: config?.globalFeeScheduleState || null,
                    selectedLocality: config?.globalFeeScheduleLocality || null,
                    selectedGpci: config?.globalFeeScheduleGPCI || null,
                };
            })
        };
    });

    return {
        localFeeSchedules,
        globalFeeSchedules
    };
}

export function groupProviderRoleConfigurations(data) {
  const result = {
    localFeeSchedules: [],
    globalFeeSchedules: []
  };

  const localMap = new Map();
  const globalMap = new Map();

  data.forEach(rule => {
    const feeScheduleConfigs = rule.providerRolePaymentGroupXref || [];

    feeScheduleConfigs.forEach(config => {
      const isGlobal = Boolean(config.globalFeeScheduleId);
      const fsId = config.feeScheduleId || config.globalFeeScheduleId;
      const fsName = config.feeSchedule?.name || config.globalFeeSchedule?.name;
      const labelId = config.feeScheduleLabelToRateXRefId || config.globalFeeScheduleLabelToRateXRefId;
      const labelName = config.feeScheduleLabelToRateXRef?.label || config.globalFeeScheduleLabelToRateXRef?.label;

      if (!fsId) return;

      const key = `${fsId}`;

      if (!isGlobal) {
        if (!localMap.has(key)) {
          localMap.set(key, {
            sourceFeeScheduleId: fsId,
            feeScheduleName: fsName,
            newFeeScheduleName: fsName || "",
            feeSchedule: config.feeSchedule,
            rules: []
          });
        }
        localMap.get(key).rules.push({
          ...rule,
          providerRolePaymentGroupXrefId: config.id,
          percentage: config.percentage,
          sourceLabel: labelName,
          sourceLabelId: labelId
        });
      } else {
        if (!globalMap.has(key)) {
          globalMap.set(key, {
            sourceFeeScheduleId: fsId,
            feeScheduleName: fsName,
            newFeeScheduleName: "",
            rules: []
          });
        }
        globalMap.get(key).rules.push({
          ...rule,
          providerRolePaymentGroupXrefId: config.id,
          percentage: config.percentage,
          sourceLabel: labelName,
          sourceLabelId: labelId
        });
      }
    });
  });

  result.localFeeSchedules = Array.from(localMap.values());
  result.globalFeeSchedules = Array.from(globalMap.values());

  return result;
}

export function mapProviderRoleRules(groupedData) {
    const localFeeSchedules = groupedData.localFeeSchedules.map(group => {
        return {
            ...group,
            isAnesthesia: group.feeSchedule?.isAnesthesia === true,
            rules: group.rules.map(r => {
                return {
                    ruleId: r.id,
                    ruleName: r.name,
                    providerRolePaymentGroupXrefId: r.providerRolePaymentGroupXrefId,
                    percentage: r.percentage,
                    sourceLabel: r.sourceLabel,
                    sourceLabelId: r.sourceLabelId,
                    targetFeeScheduleId: { id: 0, name: "Select Fee Schedule At Target" },
                    targetLabelId: null,
                    isRBRVS: false,
                    selectedState: null,
                    selectedLocality: null,
                    selectedGpci: null,
                };
            })
        };
    });

    const globalFeeSchedules = groupedData.globalFeeSchedules.map(group => {
        const isRBRVSGroup = group.feeScheduleName?.toUpperCase()?.includes("RBRVS") || group.feeScheduleName?.toUpperCase()?.includes("ANESTHESIA");
        const isDMEGroup = group.feeScheduleName?.toUpperCase()?.includes("DME");

        return {
            ...group,
            rules: group.rules.map(r => {
                const config = r.providerRolePaymentGroupXref?.find(c => c.id === r.providerRolePaymentGroupXrefId);
                return {
                    ruleId: r.id,
                    ruleName: r.name,
                    providerRolePaymentGroupXrefId: r.providerRolePaymentGroupXrefId,
                    percentage: r.percentage,
                    sourceLabel: r.sourceLabel,
                    sourceLabelId: r.sourceLabelId,
                    targetFeeScheduleId: { id: group.sourceFeeScheduleId, name: group.feeScheduleName },
                    targetLabelId: r.sourceLabelId ? { id: r.sourceLabelId, label: r.sourceLabel } : null,
                    isRBRVS: isRBRVSGroup,
                    isDME: isDMEGroup,
                    selectedState: config?.globalFeeScheduleState || null,
                    selectedLocality: config?.globalFeeScheduleLocality || null,
                    selectedGpci: config?.globalFeeScheduleGPCI || null,
                };
            })
        };
    });

    return {
        localFeeSchedules,
        globalFeeSchedules
    };
}
